import { Component } from '@angular/core';

@Component({
    selector: 'app-hora-input',
    templateUrl: './hora-input.component.html',
    styleUrls: ['./hora-input.component.css'],
    standalone: false
})
export class HoraInputComponent {
  hora: string = '';

  formatarHora() {
    // Remover caracteres não numéricos
    this.hora = this.hora.replace(/[^\d]/g, '');

    // Garantir que a string tenha no máximo 4 caracteres
    if (this.hora.length > 4) {
      this.hora = this.hora.slice(0, 4);
    }

    // Adicionar ':' entre os dois primeiros caracteres
    if (this.hora.length > 2) {
      this.hora = this.hora.slice(0, 2) + ':' + this.hora.slice(2);
    }
  }
}
